import { flattenEntry, getEntries, Page } from '@/lib/cms';
import { OpenPositionsProps } from './OpenPositions';
import { OpenPositionsStrapiProps } from './OpenPositionsStrapi';
import { HeroStrapiProps } from '../Hero/HeroStrapi';

export function transformPositions(entries: Page) {
  type CareerHeroProps = HeroStrapiProps & { jobType: string; city: string };

  return entries.data
    .map((rawEntry) => {
      const entry = flattenEntry(rawEntry);
      const heroBlock = entry.blocks.find(
        (block) => block.__component === 'hero.careers-hero'
      ) as CareerHeroProps | undefined;

      if (
        !heroBlock ||
        !heroBlock.title ||
        !heroBlock.city ||
        !heroBlock.jobType
      )
        return;

      return {
        title: heroBlock.title,
        location: heroBlock.city,
        type: heroBlock.jobType,
        button: { href: `/${entry.slug}`, children: 'Details' },
      };
    })
    .filter((entry) => entry !== undefined)
    .sort((a, b) => a.title.localeCompare(b.title));
}

export async function transformOpenPositions(
  block: OpenPositionsStrapiProps
): Promise<OpenPositionsProps> {
  const { title, pages } = block;

  if (!pages.data) return { title: title ?? '', positions: [] };

  const slugs = pages.data.map((page) => page.attributes.slug);

  const entries = await getEntries({
    contentType: '/pages',
    query: {
      filters: { slug: slugs },
      populate: { blocks: { on: { 'hero.careers-hero': { populate: '*' } } } },
    },
  });

  if (!entries?.data) return { title: title ?? '', positions: [] };

  return {
    title: title ?? '',
    positions: transformPositions(entries),
  };
}
